import { useState } from 'react';
import { SortDirection } from '@tanstack/react-table';

import { DEFAULT_SORTING } from '../../components/Table/constants/defaults';
import { Sorting } from '../../types';

/**
 * Sorting state hook
 *
 * @param initialColumn - Initial column to sort by
 * @param initialDirection - Initial sort direction
 * @returns Tuple containing sorting state and setter function
 */
export const useSortingState = (
  initialColumn: string = DEFAULT_SORTING.column,
  initialDirection: SortDirection = DEFAULT_SORTING.direction,
) => {
  const [sorting, setSorting] = useState<Sorting>({
    column: initialColumn,
    direction: initialDirection,
  });

  return [sorting, setSorting] as const;
};
